<template>
  <Loader />
</template>

<script>
import Loader from '@/components/atoms/Loader'

import Auth from '@/firebase/auth'
const auth = new Auth()

export default {
  name: 'PageSignout',
  components: {
    Loader,
  },
  async mounted() {
    try {
      await auth.signout()
      this.$notify('ログアウトしました')
      this.$router.push('/')
    } catch(error) {
      this.$notify('ログアウトに失敗しました')
      this.$router.push('/children')
    }
  },
}
</script>

<style scoped lang="scss">
.PageSignout {}
</style>
